import { ElementsMetaData, MapElement } from '@spiaggeit/map-canvas'

export function getElementsMetadata(elements: MapElement[]): ElementsMetaData {
  const metaData: ElementsMetaData = {
    maxX: -Infinity,
    maxY: -Infinity,
  }

  for (const element of elements) {
    if (element.x > metaData.maxX) {
      metaData.maxX = element.x
    }
    if (element.y > metaData.maxY) {
      metaData.maxY = element.y
    }
  }

  return metaData
}
